import styled from 'styled-components';
import { rem } from 'polished';
import DateFormat from '../DateFormat';

const StyledBoxDayMonth = styled.time`
  color: ${props => props.theme.colors.dark};
  font-family: ${props => props.theme.fonts.book};
  line-height: 0.8;
`;

const StyledDayNumber = styled(DateFormat)`
  float: left;
  font-size: ${rem('25px')};
  margin: 0 ${rem('3px')} 0 0;
`;

const StyledMonth = styled(DateFormat)`
  display: block;
  font-family: ${props => props.theme.fonts.bold};
  font-size: ${rem('13px')};
  text-transform: uppercase;
  padding-bottom: ${rem('2px')};
`;

const StyledDayText = styled(DateFormat)`
  display: block;
  font-size: ${rem('12px')};
  text-transform: capitalize;
`;

export { StyledBoxDayMonth, StyledDayNumber, StyledDayText, StyledMonth };
